import React from "react";
import { Row, Col, Container, Card, CardHeader, CardBody } from "reactstrap";
import MainHeading from "../../MainHeading";
import { useTranslation } from "react-i18next";
import "./BannerStyle.scss";
import { FaQuoteLeft } from "react-icons/fa";
const locat = require("../../../Assets/Images/stack.png");
const bell = require("../../../Assets/Images/bel.png");
const message = require("../../../Assets/Images/message.png");
const people = require("../../../Assets/Images/people.png");
const recieveTip = require("../../../Assets/Images/recieveTip.png");
const giveTip = require("../../../Assets/Images/giveTip.png");

const Partner = () => {
  const { t } = useTranslation();
  const features = [
    {
      icon: <FaQuoteLeft color="#FCA074" />,
      heading: `I love the performance feedback for the employees in my housekeeping business. Even my elderly clients can manage the app.`,
      paragraf: `Ingrid Correa  CEO Happy Homes Cleaning`,
    },
    {
      icon: <FaQuoteLeft color="#FCA074" />,
      heading: `My concierge team loves getting tips securely and instantly. They also now have a solution to “Sorry, I don’t have any small bills.” More tips mean happier staff. Thank you! `,
      paragraf: `Preston Green Owner The Prov
      `,
    },
    {
      icon: <FaQuoteLeft color="#FCA074" />,
      heading: `My valet customers are happy to Tip & Go; my average tips have increased by 18% since we started using EasyTipping at work.`,
      paragraf: `Kareem Hamada `,
    },
  ];

  return (
    <section id="canvaTestimonials" className="BannerImgEight">
      <Container fluid className="py-3 h-100">
        <Row>
          <Col md={12} className="text-center">
            <h3 className="heading my-2">
              {/* {t("AboutUs")} */}
              What Our Partners Say...
            </h3>
          </Col>
        </Row>
        <Row className="justify-content-center  h-100 mt-5">
          <Col md={10}>
            <Row className="">
              {features.map((data) => (
                <Col lg={4} md={4} className="">
                  <Card
                    className="rounded-4 text-center  bg-transparent border-0  h-100"
                    style={{ backgroundColor: `transparent` }}
                  >
                    <CardHeader className="bg-transparent border-0">
                      <h5 className="text-start">{data.icon}</h5>
                    </CardHeader>
                    <CardBody className="">
                      <h5 className="text-start nomrateFont">{data.heading}</h5>
                      <p className="text-start nomrateFont my-4">
                        {data.paragraf}
                      </p>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Partner;
